'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectors = exports.isClientHandoffAction = exports.CLIENT_HANDOFF_ACTION = exports.RenderToStringResponseType = exports.RenderToStringParamsType = exports.setupStoreAndSagas = exports.renderToString = exports.RenderParamsType = exports.render = undefined;

var _render = require('./render');

Object.defineProperty(exports, 'render', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_render).default;
    }
});
Object.defineProperty(exports, 'RenderParamsType', {
    enumerable: true,
    get: function get() {
        return _render.RenderParamsType;
    }
});

var _renderToString = require('./renderToString');

Object.defineProperty(exports, 'renderToString', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_renderToString).default;
    }
});
Object.defineProperty(exports, 'setupStoreAndSagas', {
    enumerable: true,
    get: function get() {
        return _renderToString.setupStoreAndSagas;
    }
});
Object.defineProperty(exports, 'RenderToStringParamsType', {
    enumerable: true,
    get: function get() {
        return _renderToString.RenderToStringParamsType;
    }
});
Object.defineProperty(exports, 'RenderToStringResponseType', {
    enumerable: true,
    get: function get() {
        return _renderToString.RenderToStringResponseType;
    }
});
Object.defineProperty(exports, 'CLIENT_HANDOFF_ACTION', {
    enumerable: true,
    get: function get() {
        return _renderToString.CLIENT_HANDOFF_ACTION;
    }
});
Object.defineProperty(exports, 'isClientHandoffAction', {
    enumerable: true,
    get: function get() {
        return _renderToString.isClientHandoffAction;
    }
});

var _reduxTunnel = require('@wh/redux-tunnel');

var _reduxTunnel2 = _interopRequireDefault(_reduxTunnel);

var _utilDeprecate = require('util-deprecate');

var _utilDeprecate2 = _interopRequireDefault(_utilDeprecate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @todo remove in next major version
var selectors = {
    tunnelSelector: (0, _utilDeprecate2.default)(function () {
        // eslint-disable-line flowtype/no-weak-types
        _reduxTunnel2.default.apply(undefined, arguments);
    }, 'tunnelSelector() is deprecated. Please use @wh/redux-tunnel package')
};

exports.selectors = selectors;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/site-base-app-container/dist/main/index.js
// module id = 534
// module chunks = 0